/* People's Peps — product page behaviour.
   Gallery, tabs, quantity stepper, variant pills, accordions, product pager. */
(function () {
  'use strict';

  /* Run once, however many times this file is included.

     pp-head.liquid is rendered by BOTH the header and the footer section, so
     the browser sees two <script src> tags for this file. A classic script is
     fetched once from cache but EXECUTED once per tag - only ES modules are
     de-duplicated by URL. Without this guard every delegated listener below is
     bound twice, which doubled Add to Cart, made the accordions open-then-shut
     in the same click, and stepped quantity by two. */
  if (window.__ppPdpLoaded) return;
  window.__ppPdpLoaded = true;

  var ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  /* The customizer re-renders ONE section's HTML and fires
     shopify:section:load - it does not reload the page or re-run this file.
     So every initialiser below has to be safe to call again over the whole
     document: it must skip nodes it has already wired, and it must wire the
     fresh nodes it has not. That is what this flag does. Without it, editing
     a text field in the theme editor left the section's gallery, tabs,
     accordions and rails dead, which is the classic "I edited one field and
     the section broke" report.
     Guard keys are always ppInit* so the attribute they write
     (data-pp-init-qty and friends) can never collide with a data-pp-* hook
     that a selector elsewhere depends on - dataset writes to the same
     attribute namespace, and once(box,'ppQty') would have overwritten the
     very data-pp-qty attribute that finds the element. */
  function once(el, key) {
    if (!el || el.dataset[key] === '1') return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------- gallery ---------- */
  function gallery(root) {
    var stage = root.querySelector('[data-pp-gal-stage]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pp-gal-thumb]'));
    if (!stage || !thumbs.length) return;
    var slides = Array.prototype.slice.call(stage.querySelectorAll('img'));
    if (!once(stage, 'ppInitGal')) return;

    function show(i) {
      slides.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = (i + d + thumbs.length) % thumbs.length;
        thumbs[n].focus(); show(n);
      });
    });
    /* The section opens the stage on the selected strength's own image (it
       carries is-on), so start there rather than on the first image. */
    var start = 0;
    for (var k = 0; k < slides.length; k++) {
      if (slides[k].classList.contains('is-on')) { start = k; break; }
    }
    show(start);
    /* Picking another strength moves the stage to that strength's image. The
       stage images and the thumbnails are rendered from the same media list,
       so they share an index; the thumbnail carries the media id. */
    root.addEventListener('pp:variant', function (e) {
      var id = e.detail && e.detail.media_id;
      if (!id) return;
      for (var n = 0; n < thumbs.length; n++) {
        if (thumbs[n].getAttribute('data-media-id') === String(id)) { show(n); break; }
      }
    });
  }

  /* ---------- tabs ---------- */
  function tabs(root) {
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-pp-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pp-tabpanel]'));
    if (!btns.length) return;
    if (!once(btns[0], 'ppInitTabs')) return;
    function show(key) {
      btns.forEach(function (b) { b.setAttribute('aria-selected', b.dataset.ppTab === key ? 'true' : 'false'); });
      panels.forEach(function (p) { p.classList.toggle('is-on', p.dataset.ppTabpanel === key); });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { show(b.dataset.ppTab); });
    });
    show(btns[0].dataset.ppTab);
  }

  /* ---------- quantity ---------- */
  function qty(root) {
    root.querySelectorAll('[data-pp-qty]').forEach(function (box) {
      var input = box.querySelector('input');
      if (!input) return;
      if (!once(box, 'ppInitQty')) return;
      box.querySelectorAll('button[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var min = parseInt(input.min || '1', 10);
          var v = parseInt(input.value || '1', 10) + parseInt(b.dataset.step, 10);
          input.value = String(v < min ? min : v);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- variant pills ---------- */
  function variants(root) {
    var form = root.querySelector('[data-pp-product-form]');
    if (!form) return;
    var idInput = form.querySelector('[data-pp-variant-id]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-pp-optgroup]'));
    var data = root.querySelector('[data-pp-variants]');
    if (!idInput || !groups.length || !data) return;
    if (!once(form, 'ppInitVariants')) return;

    var variantList;
    try { variantList = JSON.parse(data.textContent); } catch (e) { return; }

    var priceEl = root.querySelector('[data-pp-price]');
    var cta = root.querySelector('[data-pp-atc]');

    function selection() {
      return groups.map(function (g) {
        var on = g.querySelector('[aria-checked="true"]');
        return on ? on.dataset.value : null;
      });
    }

    function sync() {
      var sel = selection();
      var match = variantList.find(function (v) {
        return sel.every(function (s, i) { return s === null || v.options[i] === s; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
      /* the dose under the title and the nominal content follow the strength */
      if (match.dose) {
        root.querySelectorAll('[data-pp-dose], [data-pp-nominal]').forEach(function (el) { el.textContent = match.dose; });
      }
      if (cta) {
        cta.disabled = !match.available;
        cta.textContent = match.available ? (cta.dataset.label || 'Add to Cart') : 'Sold out';
      }
      if (match.url && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', match.url);
      }
      /* The gallery (above) and the product page calculator (assets/pp-calc2.js)
         follow the selected strength through this event. */
      var ev;
      try { ev = new CustomEvent('pp:variant', { bubbles: true, detail: match }); } catch (err) { ev = null; }
      if (ev) root.dispatchEvent(ev);
    }

    groups.forEach(function (g) {
      g.querySelectorAll('[data-value]').forEach(function (p) {
        p.addEventListener('click', function () {
          if (p.disabled) return;
          g.querySelectorAll('[data-value]').forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
          p.setAttribute('aria-checked', 'true');
          sync();
        });
      });
    });
  }

  /* ---------- accordions ---------- */
  function accordions(scope) {
    scope.querySelectorAll('[data-pp-acc]').forEach(function (acc) {
      if (!once(acc, 'ppInitAcc')) return;
      var single = acc.dataset.ppAcc === 'single';
      acc.querySelectorAll('.pp-acc__i').forEach(function (item) {
        var btn = item.querySelector('.pp-acc__btn');
        if (!btn) return;
        btn.setAttribute('aria-expanded', item.dataset.open === 'true' ? 'true' : 'false');
        btn.addEventListener('click', function () {
          var open = item.dataset.open === 'true';
          if (single && !open) {
            acc.querySelectorAll('.pp-acc__i').forEach(function (o) {
              o.dataset.open = 'false';
              var b = o.querySelector('.pp-acc__btn');
              if (b) b.setAttribute('aria-expanded', 'false');
            });
          }
          item.dataset.open = open ? 'false' : 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    });
  }

  /* ---------- paged product grid ---------- */
  function pagers(scope) {
    scope.querySelectorAll('[data-pp-paged]').forEach(function (wrap) {
      var pages = Array.prototype.slice.call(wrap.querySelectorAll('[data-pp-page]'));
      var btns = Array.prototype.slice.call(wrap.querySelectorAll('[data-pp-goto]'));
      if (pages.length < 2) return;
      if (!once(wrap, 'ppInitPager')) return;
      function go(n) {
        pages.forEach(function (p, i) { p.classList.toggle('is-on', i === n); });
        btns.forEach(function (b, i) { b.setAttribute('aria-current', i === n ? 'true' : 'false'); });
      }
      btns.forEach(function (b, i) { b.addEventListener('click', function () { go(i); }); });
      go(0);
    });
  }

  /* ---------- product rail: arrows + drag ---------- */
  function sliders(scope) {
    scope.querySelectorAll('[data-pp-slider]').forEach(function (wrap) {
      var rail = wrap.querySelector('[data-pp-rail-root]');
      if (!rail) return;
      if (!once(wrap, 'ppInitSlider')) return;
      var arrows = Array.prototype.slice.call(wrap.querySelectorAll('[data-pp-slide]'));

      function step() {
        var item = rail.querySelector('.pp-rail__item');
        if (!item) return rail.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
        var w = item.getBoundingClientRect().width + gap;
        var per = Math.max(1, Math.floor(rail.clientWidth / w));
        return w * per;
      }

      var dotWrap = document.querySelector('[data-pp-dots-for="' + rail.id + '"]');
      var dots = [];

      function pages() {
        return Math.max(1, Math.ceil(rail.scrollWidth / Math.max(1, rail.clientWidth)));
      }

      function buildDots() {
        if (!dotWrap) return;
        var n = pages();
        if (n === dots.length) return;
        dotWrap.textContent = '';
        dots = [];
        if (n < 2) return;
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to page ' + (i + 1));
          b.dataset.ppPage = String(i);
          b.addEventListener('click', function (e) {
            var idx = parseInt(e.currentTarget.dataset.ppPage, 10);
            rail.scrollTo({ left: idx * rail.clientWidth, behavior: 'smooth' });
          });
          dotWrap.appendChild(b);
          dots.push(b);
        }
      }

      function sync() {
        var max = rail.scrollWidth - rail.clientWidth - 1;
        arrows.forEach(function (b) {
          var dir = parseInt(b.dataset.ppSlide, 10);
          b.disabled = dir < 0 ? rail.scrollLeft <= 0 : rail.scrollLeft >= max;
        });
        if (dots.length) {
          var cur = Math.round(rail.scrollLeft / Math.max(1, rail.clientWidth));
          if (cur > dots.length - 1) cur = dots.length - 1;
          dots.forEach(function (d, i) { d.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
        }
      }

      arrows.forEach(function (b) {
        b.addEventListener('click', function () {
          rail.scrollBy({ left: step() * parseInt(b.dataset.ppSlide, 10), behavior: 'smooth' });
        });
      });
      rail.addEventListener('scroll', function () {
        window.clearTimeout(rail._ppT);
        rail._ppT = window.setTimeout(sync, 90);
      }, { passive: true });
      window.addEventListener('resize', function () { buildDots(); sync(); });
      buildDots();
      sync();

      /* pointer drag */
      if (!rail.hasAttribute('data-pp-drag')) return;
      var down = false, startX = 0, startLeft = 0, moved = 0;

      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;   /* native touch scrolling is better */
        down = true; moved = 0;
        startX = e.clientX; startLeft = rail.scrollLeft;
        /* is-dragging is NOT added here. The class turns pointer-events off
           on every card, so adding it on pointerdown made the mousedown land
           on the rail and the mouseup on the card: the click resolved to the
           rail and the product link never fired. It is added on the first
           real movement in pointermove instead, so a plain click stays a
           click and a drag still grabs. */
      });
      rail.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) {
          moved = Math.abs(dx);
          rail.classList.add('is-dragging');
          if (rail.hasPointerCapture && !rail.hasPointerCapture(e.pointerId)) {
            try { rail.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
          }
        }
        rail.scrollLeft = startLeft - dx;
      });
      function release(e) {
        if (!down) return;
        down = false;
        window.setTimeout(function () { moved = 0; }, 0);
        rail.classList.remove('is-dragging');
        if (e && rail.releasePointerCapture) {
          try { rail.releasePointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        }
        sync();
      }
      rail.addEventListener('pointerup', release);
      rail.addEventListener('pointercancel', release);
      rail.addEventListener('pointerleave', release);
      rail.addEventListener('click', function (e) {
        if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; }
      }, true);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ---------------------------------------------------------------
     Add to cart from a product card. The markup is a real <form> that
     posts to /cart/add, so this only enhances it: if the fetch fails
     for any reason the form is submitted the ordinary way and the
     browser lands on the cart page.
     --------------------------------------------------------------- */
  function cartCount(n) {
    document.querySelectorAll(
      '.cart-count-bubble span:first-child, [data-pp-cart-count], .pp-header__cart-count'
    ).forEach(function (el) { el.textContent = String(n); });
    var bub = document.querySelector('.cart-count-bubble');
    if (bub) bub.hidden = false;
  }

  /* If the theme is not running Dawn's drawer for any reason, fall back to
     the header's own cart link rather than a full page load to /cart. */
  function openFallbackDrawer() {
    var d = document.querySelector('[data-pp-cart-drawer]');
    if (d) { d.classList.add('is-open'); document.documentElement.classList.add('pp-noscroll'); return; }
    var toggle = document.querySelector('#cart-icon-bubble, .pp-iconbtn[href*="/cart"]');
    if (toggle && toggle.tagName !== 'A') toggle.click();
  }

  /* ---------------------------------------------------------------
     Read more / read less. The body is clamped by CSS; the button only
     appears when there is actually something hidden, so a two-line
     collection intro does not get a pointless toggle under it.
     --------------------------------------------------------------- */
  function moreToggles(scope) {
    scope.querySelectorAll('[data-pp-more]').forEach(function (wrap) {
      var body = wrap.querySelector('.pp-more__body');
      var btn = wrap.querySelector('.pp-more__btn');
      if (!body || !btn) return;
      if (!once(wrap, 'ppInitMore')) return;

      function overflowing() {
        return body.scrollHeight - body.clientHeight > 4;
      }
      function measure() {
        if (wrap.classList.contains('is-open')) return;
        btn.hidden = !overflowing();
      }
      measure();
      window.addEventListener('resize', measure);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open
          ? (btn.dataset.less || 'Read less')
          : (btn.dataset.more || 'Read more');
        if (!open) measure();
      });
    });
  }

  /* ---------------------------------------------------------------
     The header cart opens the drawer rather than loading /cart. The
     anchor keeps its href, so this is an enhancement: without JS, or if
     the drawer is not on the page, the link still works.
     --------------------------------------------------------------- */
  function cartOpeners(scope) {
    scope.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-pp-cart-open]');
      if (!trigger) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;
      e.preventDefault();
      drawer.open(trigger);
    });
  }

  /* ---------------------------------------------------------------
     Stepped auto-advance: hold each card for a beat, then scroll on by
     exactly one. Used where a continuous drift would be too busy.
     --------------------------------------------------------------- */
  function autoSteps(scope) {
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (still && still.matches) return;

    scope.querySelectorAll('[data-pp-autostep]').forEach(function (rail) {
      var ms = parseInt(rail.getAttribute('data-pp-autostep'), 10);
      if (!(ms > 0)) return;
      if (!once(rail, 'ppInitAutoStep')) return;
      var paused = 0, timer = null;

      function scrollable() {
        return rail.scrollWidth - rail.clientWidth > 8;
      }
      function stride() {
        var item = rail.firstElementChild;
        if (!item) return rail.clientWidth;
        var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      function step() {
        if (!rail.isConnected) { stop(); return; }
        if (paused > 0 || document.hidden || !scrollable()) return;
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (rail.scrollLeft >= max) rail.scrollTo({ left: 0, behavior: 'smooth' });
        else rail.scrollBy({ left: stride(), behavior: 'smooth' });
      }
      function start() { if (!timer) timer = window.setInterval(step, ms); }
      function stop() { window.clearInterval(timer); timer = null; }

      ['pointerenter', 'focusin', 'touchstart', 'pointerdown'].forEach(function (ev) {
        rail.addEventListener(ev, function () { paused++; }, { passive: true });
      });
      ['pointerleave', 'focusout', 'touchend', 'touchcancel', 'pointerup', 'pointercancel'].forEach(function (ev) {
        rail.addEventListener(ev, function () { if (paused > 0) paused--; }, { passive: true });
      });

      /* only while the row is actually a rail - on wide screens all five
         cards are on screen and there is nothing to advance to */
      function sync() {
        if (!rail.isConnected) { stop(); return; }
        if (scrollable()) start(); else stop();
      }
      sync();
      window.addEventListener('resize', sync);
    });
  }

  /* ---------------------------------------------------------------
     Lot lookup. The index is rendered from the products' own metafields,
     so this resolves a real released lot to its product and says plainly
     when there is no record rather than dumping the visitor into a
     search results page that will not find it either.
     --------------------------------------------------------------- */
  function lotLookup(scope) {
    scope.querySelectorAll('[data-pp-lot]').forEach(function (panel) {
      var form = panel.querySelector('[data-pp-lot-form]');
      var input = panel.querySelector('.pp-lot__input');
      var msg = panel.querySelector('[data-pp-lot-msg]');
      var raw = panel.querySelector('[data-pp-lot-index]');
      if (!form || !input || !raw) return;
      if (!once(panel, 'ppInitLot')) return;

      var rows = [];
      try { rows = JSON.parse(raw.textContent) || []; } catch (e) { rows = []; }
      var norm = function (v) { return String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); };

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = norm(input.value);
        if (!q) {
          msg.textContent = panel.getAttribute('data-msg-empty') || 'Type the identifier printed on the vial.';
          panel.dataset.ppLotState = 'idle';
          return;
        }
        var hit = null;
        for (var i = 0; i < rows.length; i++) {
          var k = norm(rows[i].lot);
          if (k === q || (q.length > 5 && k.indexOf(q) === 0)) { hit = rows[i]; break; }
        }
        if (hit) {
          panel.dataset.ppLotState = 'found';
          var found = panel.getAttribute('data-msg-found');
          msg.textContent = found
            ? found.replace('[lot]', hit.lot).replace('[title]', hit.title + (hit.state ? ' (' + hit.state + ')' : ''))
            : 'Lot ' + hit.lot + ', ' + hit.title + (hit.state ? ' (' + hit.state + ')' : '') + '. Opening the record.';
          window.setTimeout(function () { window.location.href = hit.url; }, 500);
        } else {
          panel.dataset.ppLotState = 'none';
          /* the message is section copy (Theme editor > lot lookup), so it may
             carry a link; it is written by the merchant, not the visitor */
          var none = panel.querySelector('template[data-pp-lot-none]');
          if (none && none.innerHTML.trim()) msg.innerHTML = none.innerHTML;
          else msg.textContent = 'No released lot carries that identifier. ' +
            'If the lot is held or not yet released there is no record to open yet.';
        }
      });

      input.addEventListener('input', function () {
        if (panel.dataset.ppLotState) { panel.dataset.ppLotState = ''; msg.textContent = ''; }
      });
    });
  }

  /* ---------------------------------------------------------------
     Hide the sticky header on the way down, bring it straight back on
     the way up. The threshold stops a trackpad's jitter from flapping
     it, and it always reappears at the very top of the page.
     --------------------------------------------------------------- */
  function stickyHeader() {
    var h = document.querySelector('.pp-header--sticky');
    if (!h) return;

    /* The bar cannot pin itself: position:sticky only travels inside its own
       parent, and the parent is the section wrapper Shopify emits, which is
       exactly as tall as the bar. Mark the wrapper instead - it is a direct
       child of <body> and has the whole page to travel. CSS does the same
       thing with :has(); this is the version that does not need it. */
    var host = h.closest('.shopify-section') || h.parentElement;
    if (host && host !== document.body) host.classList.add('pp-sticky-host');
    /* the class above has to be re-applied to the fresh wrapper after a header
       edit, so that part runs every time; the listeners below only once */
    if (!once(h, 'ppInitSticky')) return;

    var last = window.pageYOffset || 0;
    var shown = true, ticking = false;

    function apply() {
      ticking = false;
      var y = window.pageYOffset || 0;
      var dy = y - last;
      var h0 = h.offsetHeight || 80;

      if (y <= 2) {
        if (!shown) { h.classList.remove('is-tucked'); shown = true; }
        last = y; return;
      }
      if (Math.abs(dy) < 6) return;              /* ignore jitter */

      if (dy > 0 && y > h0 * 1.6) {
        if (shown) { h.classList.add('is-tucked'); shown = false; }
      } else if (dy < 0) {
        if (!shown) { h.classList.remove('is-tucked'); shown = true; }
      }
      last = y;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(apply); }
    }, { passive: true });

    /* never leave it hidden while something inside it has focus */
    h.addEventListener('focusin', function () {
      h.classList.remove('is-tucked'); shown = true;
    });
  }

  function cardCarts(scope) {
    scope.addEventListener('submit', function (e) {
      /* Two shapes of add-to-cart form reach here. The product cards put
         data-pp-atc on the FORM. The product page puts data-pp-atc on the
         button (variants() needs it there to flip the label and the disabled
         state) and marks its form data-pp-product-form, so the PDP has to be
         matched by that instead - without it the PDP posted natively and
         landed on /cart, which is exactly the behaviour we were asked to
         remove. */
      var form = e.target.closest('form[data-pp-atc], form[data-pp-product-form]');
      if (!form) return;
      if (!window.fetch) return;                 /* let the browser post it */
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var id = (form.querySelector('[name="id"]') || {}).value;
      if (!id) { form.submit(); return; }
      /* cards have no stepper and default to 1; the PDP has one and must be
         honoured, or a shopper asking for three gets one */
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
      if (btn) { btn.disabled = true; btn.dataset.ppLabel = btn.textContent; btn.textContent = 'Adding…'; }

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var drawer = document.querySelector('cart-drawer');
      var body = { items: [{ id: id, quantity: qty }] };
      if (drawer) body.sections = ['cart-drawer', 'cart-icon-bubble'];

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (added) {
          if (drawer && added.sections && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(added);        /* Dawn paints and opens it */
          } else {
            openFallbackDrawer();
          }
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          cartCount(cart.item_count);
          if (btn) {
            btn.textContent = 'Added';
            window.setTimeout(function () {
              btn.textContent = btn.dataset.ppLabel || 'Add to Cart';
              btn.disabled = false;
            }, 1400);
          }
          document.dispatchEvent(new CustomEvent('pp:cart:added', { detail: cart }));
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.ppLabel || 'Add to Cart'; }
          form.submit();                          /* fall back to the real post */
        });
    });
  }

  /* ---------------------------------------------------------------
     Slow continuous drift for a card rail. The item set is cloned once
     so the loop is seamless: when the scroll passes the halfway mark it
     is rewound by exactly one set, which is visually identical. Pauses
     on hover, on keyboard focus, while dragging, and for anyone who has
     asked for reduced motion.
     --------------------------------------------------------------- */
  function autoRails(scope) {
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (still && still.matches) return;

    scope.querySelectorAll('[data-pp-auto]').forEach(function (rail) {
      var speed = parseFloat(rail.getAttribute('data-pp-auto'));
      if (!(speed > 0)) return;
      var items = Array.prototype.slice.call(rail.children);
      if (items.length < 2) return;
      /* also stops the clone pass running twice and tripling the item set */
      if (!once(rail, 'ppInitAutoRail')) return;

      items.forEach(function (n) {
        var c = n.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('a,button,input,select,textarea').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        /* the reveal observer only ever watches the originals, so a clone that
           kept .pp-rise would sit at opacity 0 for ever and the section would
           look empty as soon as the rail scrolled onto the cloned set */
        c.classList.remove('pp-rise');
        c.classList.add('is-in');
        c.querySelectorAll('.pp-rise').forEach(function (el) {
          el.classList.remove('pp-rise'); el.classList.add('is-in');
        });
        rail.appendChild(c);
      });
      /* and make sure the originals are visible even if the observer never
         fires for them - a rail that has already been scrolled can leave an
         item permanently outside the observer's root margin */
      items.forEach(function (n) { n.classList.add('is-in'); });

      var dots = document.querySelector('[data-pp-dots-for="' + rail.id + '"]');
      if (dots) { dots.textContent = ''; dots.hidden = true; dots.classList.add('is-hidden'); }

      var half = 0;
      function measure() {
        /* one set = half the scrollable content, now that it is doubled */
        half = rail.scrollWidth / 2;
      }
      measure();
      window.addEventListener('resize', measure);
      if (window.ResizeObserver) new ResizeObserver(measure).observe(rail);

      /* `pos` is a float accumulator, because scrollLeft is rounded and a
         sub-pixel-per-frame step would otherwise be lost. It is re-synced
         from the element whenever anything else moves the scroll: a swipe,
         its momentum, an arrow, a focus jump. That is what lets a manual
         drag coexist with the drift instead of fighting it. */
      var paused = 0, pos = rail.scrollLeft, last = null, resumeAt = 0, cur = 0;
      function hold() { paused++; }
      function release() {
        if (paused > 0) paused--;
        /* momentum keeps running after the finger lifts, so give it a beat */
        resumeAt = performance.now() + 700;
      }
      rail.addEventListener('pointerenter', hold, { passive: true });
      rail.addEventListener('pointerleave', release, { passive: true });
      rail.addEventListener('focusin', hold, { passive: true });
      rail.addEventListener('focusout', release, { passive: true });
      rail.addEventListener('touchstart', hold, { passive: true });
      rail.addEventListener('touchend', release, { passive: true });
      rail.addEventListener('touchcancel', release, { passive: true });
      rail.addEventListener('pointerdown', hold, { passive: true });
      rail.addEventListener('pointerup', release, { passive: true });
      rail.addEventListener('pointercancel', release, { passive: true });
      document.addEventListener('visibilitychange', function () { last = null; });

      /* Run the loop only while the row is on screen, and only once the
         page has finished loading. Off screen it costs a layout every frame
         for nothing, and during load it competed with the first paint
         (about 1 s of main-thread time on a throttled phone in Lighthouse). */
      var onScreen = false, running = false;
      function kick() {
        if (running || !onScreen || !rail.isConnected) return;
        running = true; last = null;
        window.requestAnimationFrame(frame);
      }

      function frame(t) {
        /* the customizer replaced this section: let the loop end rather than
           animating a detached node for the rest of the page's life. Off
           screen, stop asking for frames; the observer restarts it. */
        if (!rail.isConnected || !onScreen) { running = false; return; }
        window.requestAnimationFrame(frame);
        if (last === null) { last = t; pos = rail.scrollLeft; return; }
        var dt = (t - last) / 1000;
        last = t;

        /* someone else moved it: adopt their position rather than snapping back */
        if (Math.abs(pos - rail.scrollLeft) > 2) pos = rail.scrollLeft;

        /* the loop seam works no matter who did the scrolling */
        if (half) {
          if (pos >= half) { pos -= half; rail.scrollLeft = pos; }
          else if (pos < 0) { pos += half; rail.scrollLeft = pos; }
        }

        if (document.hidden || !half) return;
        if (dt > 0.25) return;                    /* skipped frames: do not jump */

        /* Ramp the speed rather than switching it. Coming to rest under the
           cursor over about a third of a second reads as the row noticing
           you, where an instant stop reads as a glitch. */
        var want = (paused > 0 || t < resumeAt) ? 0 : speed;
        var ease = Math.min(1, dt / 0.34);
        cur += (want - cur) * ease;
        if (cur < 0.05) { cur = 0; return; }

        pos += cur * dt;
        rail.scrollLeft = pos;
      }

      function watch() {
        if (!window.IntersectionObserver) { onScreen = true; kick(); return; }
        new IntersectionObserver(function (entries) {
          onScreen = entries[entries.length - 1].isIntersecting;
          kick();
        }, { rootMargin: '120px 0px' }).observe(rail);
      }
      if (document.readyState === 'complete') watch();
      else window.addEventListener('load', watch, { once: true });
    });
  }

  /* Delegated on document, so replaced DOM keeps working with no re-wiring.
     These must be bound exactly once for the life of the page. */
  function wireGlobals() {
    if (window.__ppPdpGlobals) return;
    window.__ppPdpGlobals = true;
    cardCarts(document);
    cartOpeners(document);
  }

  /* Everything that binds to specific nodes. Safe to call with the whole
     document or with a single section that has just been re-rendered:
     once() skips what is already wired. */
  function initSection(root) {
    if (!root) return;
    moreToggles(root);
    lotLookup(root);
    stickyHeader();
    root.querySelectorAll('[data-pp-pdp]').forEach(function (el) {
      gallery(el); tabs(el); qty(el); variants(el);
    });
    if (root.matches && root.matches('[data-pp-pdp]')) {
      gallery(root); tabs(root); qty(root); variants(root);
    }
    accordions(root);
    pagers(root);
    sliders(root);
    autoRails(root);              /* after sliders(), so the dots stay hidden */
    autoSteps(root);
  }

  ready(function () {
    wireGlobals();
    initSection(document);
  });

  /* The customizer swaps one section's HTML in place. Re-hydrate just that
     section - the rest of the page still holds its own live handlers. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initSection(e.target);
  });
})();
